import React from "react"
import _ from "lodash"
import TextHighlights from "./TextWithHighlight"
import { Link } from 'react-router'
import { slugify } from '../../../../helpers/utils'

const ResultTitle = ({ queryResultItem }) => {
    // title is not guaranteed to exist, show nothing if that's the case
    let resultTitle = null
    if (
      queryResultItem.DocumentTitle &&
      !_.isEmpty(queryResultItem.DocumentTitle.Text)
    ) {
      resultTitle = (
        <TextHighlights textWithHighlights={queryResultItem.DocumentTitle} />
      )
    } else if (queryResultItem.DocumentURI) {
      resultTitle = queryResultItem.DocumentURI
    } else {
      return null
    }

    const uri = queryResultItem.DocumentURI
    if (uri && !_.isEmpty(queryResultItem.DocumentTitle.Text) && queryResultItem.DocumentAttributes[0].Key === 'model') {
      // will need to generate url from result item, right now missing: device name, content type values.
      resultTitle = (
        <Link to={`/faqs/${slugify(queryResultItem.DocumentTitle.Text)}?device=${queryResultItem.DocumentURI.split("/")[1]}`} onClick={() => {}}>
        {resultTitle}
       </Link>
      )
    }

    return <div className="title">{resultTitle}</div>
  }

export default ResultTitle



// WEBPACK FOOTER //
// ./src/containers/Kendra/resultsPanel/components/ResultTitle.js